"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventForm = void 0;
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var EventForm = function (_a) {
    var eventsMatch = _a.eventsMatch, eventsTimeline = _a.eventsTimeline, isBroadcasting = _a.isBroadcasting, onSelectEvent = _a.onSelectEvent, submitForm = _a.submitForm, teams = _a.teams;
    var intitialState = {
        description: '',
        selectedEvent: {},
        selectedTeam: {}
    };
    var _b = react_1.useState(intitialState), _c = _b[0], description = _c.description, selectedEvent = _c.selectedEvent, selectedTeam = _c.selectedTeam, setState = _b[1];
    var handleSelectTeam = function (selectedTeam) { return setState(function (state) { return (__assign(__assign({}, state), (state.selectedTeam.id === selectedTeam.id
        ? { selectedTeam: intitialState.selectedTeam }
        : { selectedTeam: selectedTeam }))); }); };
    var handleSelectEvent = function (selectedEvent) {
        setState(function (state) {
            var newSelectedEvent = __assign(__assign({}, state), (state.selectedEvent.event_template_id === selectedEvent.event_template_id
                ? { selectedEvent: intitialState.selectedEvent }
                : { selectedEvent: selectedEvent }));
            onSelectEvent(newSelectedEvent);
            return newSelectedEvent;
        });
    };
    return (react_1.default.createElement("div", { className: 'storybook-producer-eventform' },
        react_1.default.createElement(storybook_1.Producer.Scoreboard, { canSelect: isBroadcasting
                && !selectedEvent.hasOwnProperty('event_template_id'), onSelectTeam: handleSelectTeam, selectedTeam: selectedTeam, teams: teams }),
        react_1.default.createElement(storybook_1.Producer.EventListAvailable, { canSelect: isBroadcasting && !selectedTeam.hasOwnProperty('id'), items: eventsMatch, onSelect: handleSelectEvent, selectedEvent: selectedEvent }),
        react_1.default.createElement(storybook_1.Producer.EventListAvailable, { canSelect: isBroadcasting && selectedTeam.hasOwnProperty('id'), items: eventsTimeline, onSelect: handleSelectEvent, selectedEvent: selectedEvent }),
        react_1.default.createElement("div", { className: 'storybook-producer-stretch' }),
        react_1.default.createElement(storybook_1.Producer.EventDescription, { canSubmit: isBroadcasting
                && selectedEvent.hasOwnProperty('event_template_id'), onChange: function (description) { return setState(function (state) { return (__assign(__assign({}, state), { description: description })); }); }, onSubmit: function () { return submitForm({
                description: description,
                selectedEvent: selectedEvent,
                selectedTeam: selectedTeam
            })
                .then(function () { return setState(intitialState); })
                .catch(function (error) { return console.error(error); }); }, value: description })));
};
exports.EventForm = EventForm;
exports.EventForm.propTypes = {
    eventsMatch: prop_types_1.default.array,
    eventsTimeline: prop_types_1.default.array,
    isBroadcasting: prop_types_1.default.bool,
    onSelectEvent: prop_types_1.default.func,
    submitForm: prop_types_1.default.func,
    teams: prop_types_1.default.array
};
exports.EventForm.defaultProps = {
    eventsMatch: [],
    eventsTimeline: [],
    isBroadcasting: false,
    onSelectEvent: function () { },
    submitForm: function () { return new Promise(function (resolve, reject) { return resolve(); }); },
    teams: []
};
